<script setup>
import { reactive, ref, unref } from "vue";
import { getRequest } from "@/utils/request.js";

const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const formModel = ref({});
const pagination = reactive({
  current: 1,
  pageSize: 30,
  pageSizeOptions: ["10", "50", "100"],
  showTotal: (total, range) => {
    return range[0] + "-" + range[1] + " 共" + total + "条";
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
});
const data = ref([]);

const handleShow = (record) => {
  formModel.value = Object.assign({}, { ...record });
  loadData();
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formModel.value = Object.assign({});
  data.value = [];
};

const loadData = () => {
  const { current, pageSize } = unref(pagination);
  const requestParam = Object.assign(
    {},
    {
      pageNo: current,
      pageSize,
    },
  );
  getRequest(`/chat/message/${formModel.value.id}`, requestParam).then(
    (res) => {
      data.value = res.data.records;
      pagination.total = res.data.total;
    },
  );
};

defineExpose({
  handleShow,
  title,
});
</script>

<template>
  <a-modal
    width="1200px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @ok="handleClose"
    @cancel="handleClose"
  >
    <a-list item-layout="horizontal" :data-source="data" bordered>
      <template #renderItem="{ item }">
        <a-list-item>
          <a-list-item-meta>
            <template #title>
              {{
                formModel.userId === item.senderId
                  ? formModel.userRealName
                  : formModel.targetRealName
              }}
            </template>
            <template #avatar>
              <a-avatar
                :src="
                  $imageUrl(
                    formModel.userId === item.senderId
                      ? formModel.userAvatar
                      : formModel.targetAvatar,
                  )
                "
              />
            </template>
            <template #description>
              <template v-if="item.contentType === 1">
                {{ item.content }}
              </template>
              <template v-if="item.contentType === 2">
                <a-image-preview-group>
                  <a-image
                    width="100px"
                    :src="$imageUrl(item.content)"
                  ></a-image>
                </a-image-preview-group>
              </template>
            </template>
          </a-list-item-meta>
        </a-list-item>
      </template>
    </a-list>
    <a-pagination
      style="margin-top: 20px"
      v-model:current="pagination.current"
      v-model:page-size="pagination.pageSize"
      :total="pagination.total"
      :page-size-options="pagination.pageSizeOptions"
      :show-total="pagination.showTotal"
      :show-quick-jumper="pagination.showQuickJumper"
      :show-size-changer="pagination.showSizeChanger"
      @change="loadData"
    />
  </a-modal>
</template>

<style scoped lang="scss"></style>
